export default __webpack_public_path__ + "static/media/troutags.6a88d898.jpg";